/**
 * Domínio: UI de Contato.
 *
 * Ações sobre o contato e o painel lateral (drawer) da conversa.
 * Acesse via `contacts.events.EDIT`, `contacts.slots.SIDEBAR`.
 */
import type { InterceptContextBase } from "@/ui/types";

export const contacts = {
  /** Eventos de pipeline (intercept before/on/after). */
  events: {
    EDIT: "edit-contact",
    BLOCK: "block-contact",
    SAVE_NOTE: "save-ticket-note",
    CHANGE_KANBAN: "change-kanban-stage",
  },
  /** Slots de render. */
  slots: {
    ACTIONS: "contact-actions",
    SIDEBAR: "contact-sidebar",
  },
  hooks: {},
} as const;

/** Contato como o frontend o conhece (subconjunto estável). */
export interface UIContact {
  id: number;
  name?: string;
  number?: string;
  [k: string]: any;
}

/** edit-contact: abertura/salvamento de edição do contato. */
export interface EditContactContext extends InterceptContextBase {
  contact: UIContact;
}

/** block-contact: bloqueio do contato. */
export interface BlockContactContext extends InterceptContextBase {
  contact: UIContact;
}

/** save-ticket-note: salvar observação do ticket. */
export interface SaveTicketNoteContext extends InterceptContextBase {
  ticketId: number;
  contactId?: number;
  note: string;
}

/** change-kanban-stage: mudar etapa Kanban do ticket. */
export interface ChangeKanbanStageContext extends InterceptContextBase {
  ticketId: number;
  contactId?: number;
  stageId?: number | string;
}
